import React from "react";
import { Modal, Select, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { updateUI, bulkEditRequest } from "../../store/actions/shipment";

function BulkEditShipment() {
  const dispatch = useDispatch();
  const {
    isBulkEditOpen,
    selectedFields,
    profiles,
    shipProfiles,
    bulkEditFormData,
  } = useSelector((state) => ({
    isBulkEditOpen: state.shipment.ui.edit.bulkEdit,
    bulkEditFormData: state.shipment.ui.edit.bulkEditFormData,
    profiles:
      Array.isArray(state.shipment.data.shipProfile) &&
      state.shipment.data.shipProfile.length > 0
        ? state.shipment.data.shipProfile
        : [],
    shipProfiles:
      Array.isArray(state.shipment.data.shipProfile) &&
      state.shipment.data.shipProfile.length > 0
  ? state.shipment.data.shipProfile
      .filter((profile) => profile?.profiletype === "shipment")
      .map((profile) => ({
        value: profile?.profileid,
        label: profile?.profilename,
      }))
  : [],
    selectedFields:
      Array.isArray(state.shipment.ui.selectedFields) &&
      state.shipment.ui.selectedFields.length > 0
        ? state.shipment.ui.selectedFields.map(
            (selectedField) => selectedField?.record?.state
          )
        : [],
  }));

  const handleOk = () => {
    dispatch(bulkEditRequest());
  };
  const handleCancel = () => {
    dispatch(
      updateUI({
        key: "edit",
        value: {
          bulkEdit: false,
        },
      })
    );
  };
  const handleDatePickerOk = () => {};

  const handleChangeDatePicker = (value) => {
    dispatch(
      updateUI({
        key: "edit",
        value: {
          bulkEditFormData: {
            ...bulkEditFormData,
            startDate: value,
          },
        },
      })
    );
  };
  const handleChangeProfile = (val) => {
    if (Array.isArray(profiles) && profiles.length > 0) {
      const selectedProfile = profiles.filter((profile) => profile.profileid === val).map((profile) => ({
        id: profile.profileid,
        profilename: profile.profilename,
        locations: profile.locations
      }));
      dispatch(
        updateUI({
          key: "edit",
          value: {
            bulkEditFormData: {
              ...bulkEditFormData,
              profile: selectedProfile[0],
            },
          },
        })
      );
    }
  };
  const handleChangeOnShipmentCompletion = (val) => {
    dispatch(
      updateUI({
        key: "edit",
        value: {
          bulkEditFormData: {
            ...bulkEditFormData,
            onShipmentCompletion: val,
          },
        },
      })
    );
  };

  return (
    <Modal
      className="d-flex flex-column justify-content-center align-items-center p-2 bulk-shipment-edit"
      title=""
      open={isBulkEditOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={{
        xs: "90%",
        sm: "80%",
        md: "70%",
        lg: "68%",
        xl: "65%",
        xxl: "60%",
      }}
      footer={[
        <button key="back" className="cancel" onClick={handleCancel}>
          Cancel
        </button>,
        <button key="submit" className="update" onClick={handleOk}>
          Update
        </button>,
      ]}
    >
      <div className="py-2">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "30px",
          }}
        >
          Bulk Edit
        </div>
        <div>
          Enter the new values for the attributes to update for{" "}
          {selectedFields.length} selected shipments.
        </div>
      </div>
      <div>
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "18px",
          }}
        >
          New Values
        </div>
        {bulkEditFormData?.state === "Scheduled" && (
          <div className="d-flex flex-column justify-content-center align-items-start py-2">
            <span>Start Date</span>
            <DatePicker
              key={"start-date"}
              className="shipment-form-fields"
              value={dayjs(bulkEditFormData?.startDate || new Date())}
              onChange={handleChangeDatePicker}
              allowClear={false}
              showTime
              onOk={handleDatePickerOk}
            />
          </div>
        )}
        <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <span>Profile</span>
          <Select
            key={"profile"}
            placeholder="Select profile"
            value={bulkEditFormData?.profile?.id}
            onChange={handleChangeProfile}
            style={{
              width: "100%",
              height: "40px",
            }}
            options={[...shipProfiles]}
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <span>On shipment completion</span>
          <Select
            key={"on-shipment-completion"}
            placeholder="Select on shipment completion action"
            value={bulkEditFormData?.onShipmentCompletion}
            onChange={handleChangeOnShipmentCompletion}
            style={{
              width: "100%",
              height: "40px",
            }}
            options={[
              {
                value: "Keep this device profile",
                label: "Keep this device profile",
              },
              ...shipProfiles,
            ]}
          />
        </div>
      </div>
    </Modal>
  );
}

export default BulkEditShipment;
